/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_ProtocolInputs */

const en_reference_field_protocol = /** @type {(inputs: Reference_Field_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VAT register`)
};

/**
* | output |
* | --- |
* | "VAT register" |
*
* @param {Reference_Field_ProtocolInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_protocol = /** @type {((inputs?: Reference_Field_ProtocolInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_ProtocolInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_protocol(inputs)
});